/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_TitleInputs */

const en_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Event Group`)
};

const fr_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmenter le groupe d'evenements`)
};

const de_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Event Group`)
};

const it_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gruppo di eventi del segmento`)
};

const ru_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа событий сегмента`)
};

const es_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de eventos de segmento`)
};

const zh_cn2_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`细分事件组`)
};

const ja_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントイベントグループ`)
};

const hi_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड घटना समूह`)
};

const pt_pt2_segment_event_group_title = /** @type {(inputs: Segment_Event_Group_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo de Eventos do Segmento`)
};

/**
* | output |
* | --- |
* | "Segment Event Group" |
*
* @param {Segment_Event_Group_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_title = /** @type {((inputs?: Segment_Event_Group_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_title(inputs)
	if (locale === "de") return de_segment_event_group_title(inputs)
	if (locale === "it") return it_segment_event_group_title(inputs)
	if (locale === "ru") return ru_segment_event_group_title(inputs)
	if (locale === "es") return es_segment_event_group_title(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_title(inputs)
	if (locale === "ja") return ja_segment_event_group_title(inputs)
	if (locale === "hi") return hi_segment_event_group_title(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_title(inputs)
	return en_segment_event_group_title(inputs)
});